import { connect } from 'react-redux';
import {
  fetchCustomerAuthorizations,
  setPageNumber,
  setResultsPerPage,
  setSelectedAuthorizations,
} from '../store/customerAuthorizationSlice';
import MainPanel from './MainPanel';

const mapState = state => ({
  customerAuthorizations: state.loadingManagement.customerAuthorizations.customerAuthorizations,
  fetchingCustomerAuthorizations:
    state.loadingManagement.customerAuthorizations.fetchingCustomerAuthorizations,
  page: state.loadingManagement.customerAuthorizations.page,
  results: state.loadingManagement.customerAuthorizations.results,
  selectedAuthorizations: state.loadingManagement.customerAuthorizations.selectedAuthorizations,
  totalResults: state.loadingManagement.customerAuthorizations.totalResults,
});

const mapDispatchToProps = {
  fetchCustomerAuthorizations,
  setPageNumber,
  setResultsPerPage,
  setSelectedAuthorizations,
};

export default connect(mapState, mapDispatchToProps)(MainPanel);
